import React from 'react';
import { observer } from 'mobx-react';

import { MAX_LENGTH_CARDHOLDER_NAME } from 'app/constants/baseConstants';
import { FieldSet } from 'app/component/fieldset/FieldSet';

import { SecretWordFormItem } from './SecretWordFormItem';
import { EmailFormItem } from './EmailFormItem';
import { SmartEngFullNameFormItems } from './SmartEngFullNameFormItems';
import { OrderPageStore } from './OrderPageStore';
import { NameEngFormItem } from './LatinFormItem/NameEngFormItem';
import { SurnameEngFormItem } from './LatinFormItem/SurnameEngFormItem';

export interface PersonalDataMissingFormProps {
    pageStore: OrderPageStore;
}

export const PersonalDataMissingForm = observer(
    ({ pageStore }: PersonalDataMissingFormProps) => {
        const { orderFormStore } = pageStore;

        return (
            <FieldSet
                className={'personalDataFormFieldSet'}
                fieldsProps={[
                    {
                        className: 'fioEng',
                        title: '',
                        value: (
                            <>
                                <SurnameEngFormItem pageStore={pageStore} />
                                <NameEngFormItem pageStore={pageStore} />
                            </>
                        ),
                        isVisible: orderFormStore.isLatinEditable,
                    },
                    {
                        className: 'cardHolder',
                        title: 'Выберите для удобного отображения ФИ на карте',
                        value: (
                            <SmartEngFullNameFormItems pageStore={pageStore} />
                        ),
                        isVisible:
                            `${pageStore.orderFormStore.name} ${pageStore.orderFormStore.surname}`
                                .length > MAX_LENGTH_CARDHOLDER_NAME,
                    },
                    {
                        className: 'secretWord',
                        title: '',
                        value: (
                            <SecretWordFormItem formStore={orderFormStore} />
                        ),
                    },
                    {
                        className: 'email',
                        title: '',
                        value: <EmailFormItem formStore={orderFormStore} />,
                    },
                ]}
            />
        );
    },
);
